import {US_PHONE_AREA_CODES} from './upnest-util';

export const MAX_SMS_MESSAGE_LENGTH = 500;

export function isBlank(str) {
    return !str || /^\s*$/.test(str);
}

export function removeNonDigits(string) {
    return string != null ? string.replace(/[^0-9]/g, '') : '';
}

export function padStart(str, num, char) {
    if (!str) {
        return str;
    }
    if (String.prototype.padStart) {
        return str.padStart(num, char);
    } else {
        // IE 11 and older doesn't have padStart
        var paddedStr = str;
        for (var i = num - str.length; i > 0; i--) {
            paddedStr = char + paddedStr;
        }
        return paddedStr;
    }
}

export function formatPhoneForSeller(val, country) {
    if (!val) {
        return '';
    }
    const numbersOnly = removeNonDigits(val);
    if (!country || country === 'US') {
        let phone;
        if (numbersOnly.length === 0) {
            phone = '';
        } else if (numbersOnly.length <= 3) {
            phone = numbersOnly.substr(0, 3);
        } else if (numbersOnly.length <= 6) {
            phone = numbersOnly.substr(0, 3) + ' ' + numbersOnly.substr(3, 3);
        } else if (numbersOnly.length > 6) {
            phone = numbersOnly.substr(0, 3) + '-' + numbersOnly.substr(3, 3) + '-' + numbersOnly.substr(6, 4);
        }
        return phone;
    }
    return numbersOnly;
}

export function formatPhone(val, country) {
    if (!val) {
        return '';
    }
    const numbersOnly = removeNonDigits(val);
    if (!country || country === 'US') {
        let phone;
        if (numbersOnly.length === 0) {
            phone = '';
        } else if (numbersOnly.length <= 3) {
            phone = '(' + numbersOnly.substr(0, 3);
        } else if (numbersOnly.length <= 6) {
            phone = '(' + numbersOnly.substr(0, 3) + ')' + numbersOnly.substr(3, 3);
        } else if (numbersOnly.length > 6) {
            phone = '(' + numbersOnly.substr(0, 3) + ') ' + numbersOnly.substr(3, 3) + '-' + numbersOnly.substr(6, 4);
        }
        return phone;
    }
    return numbersOnly;
}

export function formatPrice(num) {
    if (!num) {
        return '$';
    }
    return (
        '$' +
        Math.round(num)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    );
}

export function formatCommission(value, options) {
    if (value == null || isNaN(value) || !isFinite(value)) {
        return null;
    }
    var defaultOptions = {
        digits: 2,
        removeTrailingZeros: false
    };
    if (typeof options == 'number') {
        var digits = options;
        options = $.extend({}, defaultOptions, {digits: digits});
    } else {
        options = $.extend({}, defaultOptions, options);
    }
    var str = value.toFixed(options.digits) + '%';
    if (options.removeTrailingZeros) {
        str = str.replace(/\.?0+%$/, '%');
    }
    return str;
}

export function formatFileSize(size) {
    const doFormat = function (value, suffix) {
        return (value < 100 ? value.toFixed(1).replace(/0+$/, '') : Math.round(value)) + ' ' + suffix;
    };
    if (size < 1024) {
        return size + ' bytes';
    }
    size /= 1024;
    if (size < 1024) {
        return doFormat(size, 'KB');
    }
    size /= 1024;
    if (size < 1024) {
        return doFormat(size, 'MB');
    }
    return doFormat(size, 'GB');
}

export function formatDuration(ms) {
    var s = Math.floor((ms / 1000) % 60);
    var m = Math.floor((ms / 1000 / 60) % 60);
    var h = Math.floor(ms / 1000 / 3600);
    return [padStart(h.toString(), 2, '0'), padStart(m.toString(), 2, '0'), padStart(s.toString(), 2, '0')].join(':');
}

export function pluralize(n, singular, plural) {
    if (n == 1) {
        return n + ' ' + singular;
    }
    if (!plural) {
        plural = singular + (/(s|x|z|ch|sh)$/.test(singular) ? 'es' : 's');
    }
    return n + ' ' + plural;
}

export function formatDollarValue(amount, hideDollarSign) {
    const formattedString = amount ? '$' + amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '$';
    return hideDollarSign ? formattedString.replace('$', '') : formattedString;
}

export function parseDollarValue(value) {
    return value ? +value.toString().replace(/\D/g, '') : null;
}

export function isValidDollarValue(value) {
    return /^\\$[0-9]{0,3}(,[0-9]{3})*$/.test(value.toString());
}

export function formatPercentageValue(value) {
    if (value == null) {
        return null;
    }
    const match = value.toString().match(/^(\d+\.?\d*%?).*$/);
    if (match) {
        return match[1];
    }
    return null;
}

export function isValidEmailAddress(emailAddress) {
    const pattern =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
    return pattern.test(emailAddress);
}

export function isValidUSPhone(value) {
    if (!value) {
        return false;
    }
    const phone = removeNonDigits(value.toString());
    if (phone.length != 10) {
        return false;
    }
    const areaCode = phone.substring(0, 3);
    return US_PHONE_AREA_CODES.includes(+areaCode);
}

export function isValidUSPhoneRelaxed(value) {
    if (!value) {
        return false;
    }
    value = value.replace(/\s+/g, '');
    return value.length > 9 && value.match(/^(\+?1-?)?(\([2-9]\d{2}\)|[2-9]\d{2})-?[2-9]\d{2}-?\d{4}$/);
}

export function isValidCityOrZip(value) {
    return /^([0-9]{5}|[a-zA-Z][a-zA-Z,'-\\. ]{0,49})$/.test(value.toString());
}

export function isValidCity(value) {
    return /^([a-zA-Z][a-zA-Z,'-\\. ]{0,49})$/.test(value.toString());
}

export function isValidCityAndState(value) {
    return /^[a-z'.\-\s]+[\s,]+\w{2,}$/i.test(value.toString());
}

export function isValidCityAndShortState(value) {
    return /^[a-z'.-]+[\s,]+\w{2}$/i.test(value.toString());
}

export function isValidCityStateOrZip(value) {
    return /['a-zA-Z ]+,\s*[a-zA-Z].*|\b\d{5}\b/i.test(value.toString());
}

export function isValidAddress(value, optionalZip) {
    // 1. House number
    // 2. Street and city - at least 2 words
    // 3. Everything else (in case street & city are more than 2 words)
    // 4. State - 2 characters
    // 5. ZIP code - 5 digits
    if (optionalZip) {
        return /^(\d+|\d+\-\d+)[\s,]+[\w'.-]+[\s,\w'.-]+[,]+[\w'.\-\s]+[,].+/i.test(value.toString());
    }
    return /^(\d+|\d+\-\d+)[\s,]+[\w'.-]+[\s,\w'.-]+[,]+[\w'.\-\s]+[,].+\d{5}$/i.test(value.toString());
}

export function isValidStreetCityState(value) {
    return /^\d+(?:-\d+)?\s+.{5,}\s*,\s*.{3,}\s*,\s*\w{2}.*$/i.test(value.toString());
}

export function countWords(value) {
    return value.match(/\b\w+\b/g).length;
}

export function getFirstName(name) {
    if (name && name.indexOf('The ') === 0) {
        return name;
    }
    return name && name.split(' ')[0];
}

export function getLastName(name) {
    if (name && name.indexOf('The ') === 0) {
        return name && name.split(' ')[2];
    }
    return name && name.split(' ')[1];
}

export function abbreviateAgentName(name) {
    if (!name) {
        return name;
    }
    const split = name.split(/ (?:&|and) /gi);
    if (split && split.length > 1) {
        const components = [];
        for (const i in split) {
            components.push(abbreviateAgentName(split[i].trim()));
        }
        return components.join(' & ');
    }
    const match = name.match(/the (\w+) (\w)\w+(.*)/i);
    if (match) {
        return `The ${match[1]} ${match[2]}.${match[3]}`;
    }
    const name_parts = name.split(' ');
    name_parts[name_parts.length - 1] = name_parts[name_parts.length - 1].substring(0, 1) + '.';
    return name_parts.join(' ');
}

export function isValidYouTubeOrZiggeoURL(url) {
    if (!url.includes('ziggeo') && !url.includes('youtu')) {
        return false;
    }

    const youtubeRegex =
        /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/(watch\?v=|embed\/|shorts\/)?([a-zA-Z0-9_-]{11})/;

    // Updated Ziggeo regex to also handle CDN URLs
    const ziggeoRegex =
        /^(https?:\/\/)?(www\.)?(ziggeo\.com\/app\/[a-zA-Z0-9_-]+\/video\/[a-zA-Z0-9_-]+|video-cdn\.ziggeo\.com\/v1\/applications\/[a-zA-Z0-9_-]+\/videos\/[a-zA-Z0-9_-]+\/video\.mp4)$/;

    // Check if the URL matches either YouTube or Ziggeo regex
    return youtubeRegex.test(url) || ziggeoRegex.test(url);
}

export function getYouTubeVideoId(videoUrl) {
    if (isBlank(videoUrl)) {
        return videoUrl;
    }
    const regex =
        /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;
    const match = regex.exec(videoUrl);
    return match ? match[1] : null;
}

export function formatNumberKM(num) {
    if (num >= 1e9) {
        return (num / 1e9).toFixed(2).replace(/\.0$/, '') + 'B';
    }
    if (num >= 1000000) {
        return (num / 1000000).toFixed(2).replace(/\.0$/, '') + 'M';
    }
    if (num >= 1000) {
        return (num / 1000).toFixed(0).replace(/\.0$/, '') + 'K';
    }
    return num;
}

export function getRealNamingAppend(variables) {
    const {real_name_append} = variables;
    if (!real_name_append) return null;
    return ` ${real_name_append}`;
}

export function isValidCityAndStateInShort(value) {
    return /^(?=.{5,50}$)['a-zA-Z ]+,\s*[a-zA-Z]{2}$/.test(value.toString().trim());
}

export function isValidFullName(name) {
    if (isBlank(name)) {
        return 'Please enter your first and last name.';
    }
    const minNameLength = 5;
    if (name.length < minNameLength) {
        return `Please enter at least ${minNameLength} characters.`;
    }
    const maxNameLength = 100;
    if (name.length > 100) {
        return `Please enter no more than ${maxNameLength} characters.`;
    }
    if (countWords(name) < 2) {
        return 'Please enter your first and last name.';
    }
    if (!/^[A-Za-z\u0300-\u0315-.,'’ ]+$/.test(name)) {
        return "Only A-Z, a-z, comma, apostrophe, period and hyphen ( , ' ’ . - ) are allowed.";
    }
    return '';
}

export function isValidFullAddress(address) {
    const FULL_ADDRESS_REGEX = /^(\d+|\d+-\d+)[\s,]+[\w'.-]+[\s,\w'.\-#]+[,]+[\w'.\-\s]+[,].+/;
    if (isBlank(address)) {
        return 'Please enter your address.';
    }
    if (!FULL_ADDRESS_REGEX.test(address)) {
        return 'Please enter a valid address, e.g. 1 Main St, Austin, TX 12345.';
    }
    return '';
}

export function getAbTestListId(experiments) {
    if (!experiments || typeof experiments !== 'object') {
        return window.experimentation && experimentation.getAbTestListId();
    }
    return Object.keys(experiments)
        .map(key => (experiments[key] ? `${key}:${experiments[key]?.variation_key}` : ''))
        .join(',');
}

export function removehtmlTagsFromString(str) {
    if (!str) {
        return '';
    }
    return str.replace(/<[^>]*>?/gm, '');
}

export function formatPhoneNumber(phoneNumber) {
    const unformatted = ('' + phoneNumber).replace(/\D/g, '');

    if (unformatted.length === 0) {
        return '';
    }

    if (unformatted.length <= 3) {
        return `(${unformatted}`;
    }

    if (unformatted.length <= 6) {
        return `(${unformatted.slice(0, 3)}) ${unformatted.slice(3)}`;
    }

    return `(${unformatted.slice(0, 3)}) ${unformatted.slice(3, 6)}-${unformatted.slice(6, 10)}`;
}
export const getOS = () => {
    if (!navigator || !navigator.userAgent) {
        return 'Unknown';
    }
    const userAgent = navigator.userAgent || '';
    if (userAgent.includes('Win')) return 'Windows';
    if (userAgent.includes('Mac')) return 'MacOS';
    if (userAgent.includes('Linux')) return 'Linux';
    if (userAgent.includes('Android')) return 'Android';
    if (userAgent.includes('like Mac')) return 'iOS';
    return 'Unknown';
};
